// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type BodyFileDescriptorBulkRestart,
  BodyFileDescriptorBulkRestartFromJSON,
  BodyFileDescriptorBulkRestartToJSON,
} from "../models/BodyFileDescriptorBulkRestart";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type FileDescriptorRead,
  FileDescriptorReadFromJSON,
  FileDescriptorReadToJSON,
} from "../models/FileDescriptorRead";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";
import { type Values, ValuesFromJSON, ValuesToJSON } from "../models/Values";

export interface FileDescriptorBulkRestartRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  bodyFileDescriptorBulkRestart: BodyFileDescriptorBulkRestart;
}

export interface FileDescriptorRetrieveRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
}

export interface FileDescriptorUpdateMetaRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  values: Values;
}

export interface FileDescriptorViewRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  viewType: string;
}

export interface FileDescriptorWmsRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  fileDescriptorId: string;
}

export interface PublicationFileDescriptorViewRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  publicationId: string;
  /**
   *
   */
  fileDescriptorId: string;
  /**
   *
   */
  viewType: string;
}

/**
 *
 */
export class FileDescriptorsApi extends runtime.BaseAPI {
  /**
   * Creates request options for fileDescriptorBulkRestart without sending the request
   */
  async fileDescriptorBulkRestartRequestOpts(
    requestParameters: FileDescriptorBulkRestartRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling fileDescriptorBulkRestart().'
      );
    }

    if (requestParameters["bodyFileDescriptorBulkRestart"] == null) {
      throw new runtime.RequiredError(
        "bodyFileDescriptorBulkRestart",
        'Required parameter "bodyFileDescriptorBulkRestart" was null or undefined when calling fileDescriptorBulkRestart().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptor-bulk-restart`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: BodyFileDescriptorBulkRestartToJSON(requestParameters["bodyFileDescriptorBulkRestart"]),
    };
  }

  /**
   * Manual way to (asynchronously) regenerate file descriptors in bulk.
   */
  async fileDescriptorBulkRestartRaw(
    requestParameters: FileDescriptorBulkRestartRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.fileDescriptorBulkRestartRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * Manual way to (asynchronously) regenerate file descriptors in bulk.
   */
  async fileDescriptorBulkRestart(
    requestParameters: FileDescriptorBulkRestartRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.fileDescriptorBulkRestartRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for fileDescriptorRetrieve without sending the request
   */
  async fileDescriptorRetrieveRequestOpts(
    requestParameters: FileDescriptorRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling fileDescriptorRetrieve().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling fileDescriptorRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual file.
   * show file descriptor
   */
  async fileDescriptorRetrieveRaw(
    requestParameters: FileDescriptorRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileDescriptorRead>> {
    const requestOptions = await this.fileDescriptorRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FileDescriptorReadFromJSON(jsonValue)
    );
  }

  /**
   * Return detailed information of an individual file.
   * show file descriptor
   */
  async fileDescriptorRetrieve(
    requestParameters: FileDescriptorRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileDescriptorRead> {
    const response = await this.fileDescriptorRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for fileDescriptorUpdateMeta without sending the request
   */
  async fileDescriptorUpdateMetaRequestOpts(
    requestParameters: FileDescriptorUpdateMetaRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling fileDescriptorUpdateMeta().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling fileDescriptorUpdateMeta().'
      );
    }

    if (requestParameters["values"] == null) {
      throw new runtime.RequiredError(
        "values",
        'Required parameter "values" was null or undefined when calling fileDescriptorUpdateMeta().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_write",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/meta`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: ValuesToJSON(requestParameters["values"]),
    };
  }

  /**
   * Partially update the user supplied meta of a file descriptor. This follows RFC7386 JSON Merge patch conventions.
   * update file descriptor meta
   */
  async fileDescriptorUpdateMetaRaw(
    requestParameters: FileDescriptorUpdateMetaRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<FileDescriptorRead>> {
    const requestOptions = await this.fileDescriptorUpdateMetaRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FileDescriptorReadFromJSON(jsonValue)
    );
  }

  /**
   * Partially update the user supplied meta of a file descriptor. This follows RFC7386 JSON Merge patch conventions.
   * update file descriptor meta
   */
  async fileDescriptorUpdateMeta(
    requestParameters: FileDescriptorUpdateMetaRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<FileDescriptorRead> {
    const response = await this.fileDescriptorUpdateMetaRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for fileDescriptorView without sending the request
   */
  async fileDescriptorViewRequestOpts(
    requestParameters: FileDescriptorViewRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling fileDescriptorView().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling fileDescriptorView().'
      );
    }

    if (requestParameters["viewType"] == null) {
      throw new runtime.RequiredError(
        "viewType",
        'Required parameter "viewType" was null or undefined when calling fileDescriptorView().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/{view_type}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{view_type}",
      encodeURIComponent(String(requestParameters["viewType"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * query file descriptor view
   */
  async fileDescriptorViewRaw(
    requestParameters: FileDescriptorViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.fileDescriptorViewRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * query file descriptor view
   */
  async fileDescriptorView(
    requestParameters: FileDescriptorViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.fileDescriptorViewRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for fileDescriptorWms without sending the request
   */
  async fileDescriptorWmsRequestOpts(
    requestParameters: FileDescriptorWmsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling fileDescriptorWms().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling fileDescriptorWms().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "project_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/file-descriptors/{file_descriptor_id}/wms`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * query file descriptor view
   */
  async fileDescriptorWmsRaw(
    requestParameters: FileDescriptorWmsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.fileDescriptorWmsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * query file descriptor view
   */
  async fileDescriptorWms(
    requestParameters: FileDescriptorWmsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.fileDescriptorWmsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for publicationFileDescriptorView without sending the request
   * @deprecated
   */
  async publicationFileDescriptorViewRequestOpts(
    requestParameters: PublicationFileDescriptorViewRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling publicationFileDescriptorView().'
      );
    }

    if (requestParameters["publicationId"] == null) {
      throw new runtime.RequiredError(
        "publicationId",
        'Required parameter "publicationId" was null or undefined when calling publicationFileDescriptorView().'
      );
    }

    if (requestParameters["fileDescriptorId"] == null) {
      throw new runtime.RequiredError(
        "fileDescriptorId",
        'Required parameter "fileDescriptorId" was null or undefined when calling publicationFileDescriptorView().'
      );
    }

    if (requestParameters["viewType"] == null) {
      throw new runtime.RequiredError(
        "viewType",
        'Required parameter "viewType" was null or undefined when calling publicationFileDescriptorView().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "publication_read",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/publications/{publication_id}/file-descriptors/{file_descriptor_id}/{view_type}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );
    urlPath = urlPath.replace(
      "{publication_id}",
      encodeURIComponent(String(requestParameters["publicationId"]))
    );
    urlPath = urlPath.replace(
      "{file_descriptor_id}",
      encodeURIComponent(String(requestParameters["fileDescriptorId"]))
    );
    urlPath = urlPath.replace(
      "{view_type}",
      encodeURIComponent(String(requestParameters["viewType"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * query file descriptor view in a publication
   * @deprecated
   */
  async publicationFileDescriptorViewRaw(
    requestParameters: PublicationFileDescriptorViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<any>> {
    const requestOptions = await this.publicationFileDescriptorViewRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new runtime.JSONApiResponse<any>(response);
    } else {
      return new runtime.TextApiResponse(response) as any;
    }
  }

  /**
   * query file descriptor view in a publication
   * @deprecated
   */
  async publicationFileDescriptorView(
    requestParameters: PublicationFileDescriptorViewRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<any> {
    const response = await this.publicationFileDescriptorViewRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
